__webpack_require__.p = "https://subscribe.preprod.weenect.com/";